import { call, put } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';

import { URLS } from '../../../consts/endpoints';
import { actions as reduxActions } from '../reducers';
import { actions as sagaActions, GET_SUBSRIPTIONS } from './types';

import { getData } from '../../../utils/http';
import { doesArrayHasLength, isArray } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import { mapProvidersOptions } from '../../orderNewSimcard/actions/getSelectOptions';
import { mapPrice } from '../../../pages/simCardsIoT/actions/getProducts';

export function getAllSubsciptions({
  clientId,
  setIsLoading,
  lang,
  accountReference,
  setProvidersOptions
}) {
  return {
    type: sagaActions[GET_SUBSRIPTIONS],
    clientId,
    setIsLoading,
    lang,
    accountReference,
    setProvidersOptions
  };
}

export function* getSupscriptions({
  clientId,
  lang,
  setIsLoading,
  accountReference,
  setProvidersOptions
}) {
  yield call(setIsLoading, true);
  let subscriptions = [];
  try {
    const response = yield call(
      getData,
      `${URLS.QUOTE_CLIENTS}/${clientId}/products?account_reference=${accountReference}&category=Mobil Abonnementer`
    );

    if (isArray(response?.[accountReference])) {
      subscriptions = response?.[accountReference];
    }
  } catch {
    yield call(setIsLoading, false);
  }

  const mappedSubscriptions = yield call(mapSubscriptionsForSelect, {
    subscriptions,
    lang
  });

  if (mappedSubscriptions.length > 0) {
    const providersOptions = mapProvidersOptions({
      filteredProducts: subscriptions
    });

    yield call(setProvidersOptions, providersOptions);
  }

  yield put(reduxActions.setMobileSubscriptions(mappedSubscriptions));
  yield call(setIsLoading, false);
}

function* watchGetSupscriptions() {
  yield takeLatest(sagaActions[GET_SUBSRIPTIONS], getSupscriptions);
}

export default watchGetSupscriptions();

export function mapSubscriptionsForSelect({ subscriptions = [], lang }) {
  if (!doesArrayHasLength(subscriptions)) {
    return subscriptions;
  }

  const selectOptions = subscriptions
    .filter(item => item.salesAllowed === true)
    .sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
    .map(item => {
      const label = Optional(item.translations?.sku?.[lang]).or(
        Optional(item.translations?.sku?.default).or('')
      );
      return {
        ...item,
        value: item.sku,
        label: (
          <div>
            {item.name}{' '}
            <small>
              <i>{mapPrice(item)} DKK</i>
            </small>
          </div>
        )
      };
    });
  return [{ value: '', label: '' }, ...selectOptions];
}
